import { LegalPage } from './_LegalPage';

export function Terms() {
  return <LegalPage docKey="terms" />;
}
